import { render, staticRenderFns } from "./Schema.vue?vue&type=template&id=67c44fa8&scoped=true"
import script from "./Schema.vue?vue&type=script&lang=js"
export * from "./Schema.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c44fa8",
  null
  
)

export default component.exports